export enum VisualSearchAPIResponse {
  UNKNOWN,
  FETCHING,
  FETCHED,
  FAILED
}

export interface QnaItem {
  question: string;
  answer: string;
}
